import xhr from "../utils/fetch";

const add = async (userId: string, requirement: any) => {
  return await xhr({
    url: `/u/${userId}/post-requirement`,
    method: "POST",
    body: requirement
  }).then(res => res.data)
    .catch(err => { throw err })
};

const get = async (userId: string) => {
  return await xhr({
    url: `/u/${userId}/post-requirement`,
    method: "GET",
  }).then(res => res.data)
    .catch(err => { throw err })
};

const update = async (userId: string, id: string, body: any) => {
  return await xhr({
    url: `/u/${userId}/post-requirement/${id}`,
    method: "PUT",
    body: body
  }).then(res => res.data)
    .catch(err => { throw err })
};

const remove = async (userId: string, id: string) => {
  return await xhr({
    url: `/u/${userId}/post-requirement/${id}`,
    method: "DELETE",
  }).then(res => res.data)
    .catch(err => { throw err })
};

const postRequirementApi = {
  add,
  get,
  update,
  remove,
};

export default postRequirementApi;
